/**
 * Created by olga on 26.09.2023
 */

const CircleCountdown = cleverapps.Spine.extend({
    ctor: function (onComplete, offer) {
        this.onComplete = onComplete;
        this.withBomb = offer.reward === Prolongation.REWARDS.BOMB;
        const animation = this.withBomb ? bundles.prolongation_window.jsons.bomb_timer_json : bundles.prolongation_window.jsons.timer_json;
        this._super(animation);

        this.timeScale = 1;
        this.currentNum = 10;
        const font = this.withBomb ? cleverapps.styles.FONTS.CIRCLE_BOMB_COUNTDOWN_TEXT : cleverapps.styles.FONTS.CIRCLE_COUNTDOWN_TEXT;
        this.numberNode = cleverapps.UI.generateImageText("0", font);
        this.addChild(this.numberNode);
        this.numberNode.setAlignment(cleverapps.styles.CircleCountdown);

        this.isShown = false;
    },

    show: function () {
        this.isShown = true;
        if (cleverapps.settings.music) {
            cleverapps.settings.toggleMusic();
            this.toggledMusic = true;
        }
        this.setAnimation(0, "open", false);
        if (!this.withBomb) {
            cleverapps.effects.fire("prolongation.timer.start");
            this.numberNode.runAction(new cc.Sequence(
                StandartAnimations.countTo(this.numberNode, 10, {
                    duration: 0.6
                }),
                StandartAnimations.pulse(this, {
                    duration: 0.6
                })
            ));
        } else {
            this.numberNode.setString(this.currentNum.toString());
        }
        this.setCompleteListener(() => {
            this.isShown = true;
            this.setAnimation(0, "animation", false);
            this.setStartListener(() => {
                this.countDownAction();
            });
            this.setCompleteListener(this.onComplete);
        });
    },

    countDownAction: function () {
        this.numberNode.setString(this.currentNum.toString());

        let effect;
        if (this.currentNum > 0) {
            effect = this.withBomb ? "prolongation.bomb_timer.tick" : "prolongation.timer.tick";
        } else {
            effect = this.withBomb ? "prolongation.bomb_timer.tick.zero" : "prolongation.timer.tick.zero";
        }

        cleverapps.effects.fire(effect);

        if (!this.withBomb) {
            if (this.currentNum < 6 && this.currentNum > 3) {
                this.numberNode.setColor(cleverapps.styles.COLORS.ORANGE);
            } else if (this.currentNum < 3) {
                this.numberNode.setColor(cleverapps.styles.COLORS.COLOR_RED);
            }
        }
        this.numberNode.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1).easing(cc.easeCubicActionOut()),
            new cc.DelayTime(0.6).easing(cc.easeElasticIn(0.5)),
            new cc.ScaleTo(0.3, 0).easing(cc.easeCubicActionIn()),
            new cc.CallFunc(() => {
                this.currentNum--;
                if (this.currentNum >= 0) {
                    this.countDownAction();
                } else if (this.withBomb) {
                    this.numberNode.removeFromParent();
                    cleverapps.effects.fire("prolongation.timer.explode");
                }
            })
        ));
    },

    pauseAction: function () {
        this.numberNode.pause();
        this.setTimeScale(0);
    },

    resumeAction: function () {
        this.setTimeScale(this.timeScale);
        this.numberNode.resume();
    },

    cleanup: function () {
        this._super();
        if (this.toggledMusic) {
            cleverapps.settings.toggleMusic();
        }
    }

});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CIRCLE_COUNTDOWN_TEXT: {
        name: "nostroke",
        size: 80,
        color: cleverapps.styles.COLORS.COLOR_BROWN_2
    },

    CIRCLE_BOMB_COUNTDOWN_TEXT: {
        name: "nostroke",
        size: 80,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.CircleCountdown = {
    x: {
        align: "center",
        dx: 5
    },
    y: {
        align: "center",
        dy: -10
    }
};